<template>
  <div>
    <vs-popup :title="$t('AddItem')" :active.sync="showModal" fullscreen>
      <form class="p-0">
        <p class="text-center">
          لیست کالاهای در کد تخفیف
          <strong>{{ currentDiscount.code }}</strong>
          و عنوان
          <strong>{{ currentDiscount.title }}</strong>
        </p>
        <div class="vx-row mb-32">
          <div class="vx-col pb-24 w-full">
            <label class="vs-select--label">{{ $t("Product") }}</label>
            <treeselect
              class="mb-32"
              name="products"
              :multiple="true"
              :placeholder="$t('Search')"
              :async="true"
              :load-options="loadOptions"
              @select="selectItem($event)"
            />
            <div class="vx-row">
              <div class="vx-col w-full mb-base">
                <vs-table :data="rowGrid" ref="table">
                  <template slot="thead">
                    <vs-th style="width: 3%">#</vs-th>
                    <vs-th style="width: 30%">{{ $t("ProductName") }}</vs-th>
                    <vs-th style="width: 25%">{{ $t("PersianName") }}</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr
                      v-for="(tr, indextr) in data"
                      :data="tr"
                      :key="indextr"
                    >
                      <vs-td :data="data[indextr]">
                        {{ parseInt(indextr) + 1 }}
                      </vs-td>
                      <vs-td :data="data[indextr].name.name">
                        {{ data[indextr].name.name }}
                      </vs-td>
                      <vs-td :data="data[indextr].name.persianName">
                        {{ data[indextr].name.persianName }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
        <vs-button @click.prevent="submitForm()" class="float-right mb-4">
          {{ $t("storage") }}
        </vs-button>
      </form>
    </vs-popup>
  </div>
</template>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { mapActions } from "vuex";
export default {
  name: "saleManagement_PublicDiscount_ModifyPopup",
  props: {
    show: { default: false },
    currentDiscount: {},
  },
  data() {
    return {
      modelAPI: "",
      ServiceURL: "",
      rowGrid: {},
      notProducts: false,

      modelSetting: {
        discountId: "",
        setting: {
          contractId: 1,
          brandIds: [],
          genericProductIds: [],
          productIds: [],
          searchQueryNew: "",
          searchQueryOld: "",
        },
      },
    };
  },
  components: {
    Treeselect,
    DataGrid,
  },

  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },

  methods: {
    ...mapActions({
      fetchSearch: "publicDiscountCode/fetchSearch",
      createSetting: "voucher/createSetting",
      promotionProducts: "voucher/promotionProducts",
    }),
    selectItem(rows) {
      this.modelSetting.setting.productIds[
        this.modelSetting.setting.productIds.length
      ] = rows.id;
    },

    submitForm() {
      this.modelSetting.discountId = this.currentDiscount.id;
      this.createSetting(this.modelSetting).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.$emit("finish");
        });
        this.$router.push("/PublicDiscountCodes/Index");

        this.modelSetting = {};
      });
    },
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.modelAPI = "productInfo=" + searchQuery;
            this.fetchSearch(this.modelAPI).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.currentDiscount.setting) {
          for (
            let index = 0;
            index < this.currentDiscount.setting.productIds.length;
            index++
          ) {
            this.ServiceURL +=
              "productIds=" + this.currentDiscount.setting.productIds[index];
            if (index < this.currentDiscount.setting.productIds.length - 1) {
              this.ServiceURL += "&";
            }
          }

          this.promotionProducts(this.ServiceURL).then((r) => {
            this.rowGrid = r;
            this.ServiceURL = "";
            this.notProducts = false;
          });
        } else {
          this.notProducts = true;
          this.rowGrid = {};
        }
        this.ServiceURL = "";
      }
    },
  },
};
</script>
